import React, { Component } from 'react';
import {Link, Redirect,useParams,withRouter} from "react-router-dom";
import {CheckVal} from "./../../utils/functions";
import {GetCoverageSummaryPackage,DeleteDbItem,UpdateDbItem} from './../../utils/dbFunctions';
import BackButton from './../../components/backButton';
import ParseEditableInput from './../../components/adminFormFields/parseEditableInput';
import ParseEditableBoolean from './../../components/adminFormFields/parseEditableBoolean';
import ParseEditableTextarea from './../../components/adminFormFields/parseEditableTextarea';
import ParseRelationalArray from './../../components/adminFormFields/parseRelationalArray';

export class AdminCoverageSummaryEditPackage extends Component {
  constructor(props) {
      super(props);
      this.state={
        items:[]
      };
  }
  componentDidMount = async() =>{
    let val = await CheckVal();
    let { id } = this.props.match.params;
    let item = await GetCoverageSummaryPackage(id);
    console.log(item)
    this.setState({
      item:item
    })
  }
  onHexColorChange = async (e) =>{
    let value = e.target.value;
    if(value && value.indexOf('#') == -1){
      value = '#'+value
    }
    let result = await UpdateDbItem(this.state.item.id,'CoveragePackages',[{key:'color',val:value}])
    this.setState({
      item:result
    })
  }
  delete = async() =>{
    var response = window.confirm("Are you sure you want to delete!");
    if (response == true) {
      await DeleteDbItem(this.state.item.id,'CoveragePackages')
      this.props.history.goBack()
    } else {
      return false
    }
  }
  render() {
    return (
      <div className="full-height full-width">
        <div className="admin-hero-padding primary-background-dark">
          <div className="small-padding">
            <BackButton />
            <div className="row" style={{marginBottom:"10px"}}>
              <h2 className="white" style={{marginBottom:'0px'}}>{this.state.item && this.state.item.attributes.name}</h2>
            </div>
          </div>
        </div>
        <div className="small-padding">
          <div className="max-width-container" style={{marginLeft:0}}>
            {this.state.item &&
              <div>
                <div className="small-top-margin">
                  <h5>{'Package Name'}</h5>
                  <ParseEditableInput
                    parseclass="CoveragePackages"
                    parseobjectid={this.state.item.id}
                    parsekey="name"
                    parsevalue={this.state.item.attributes.name}
                    placeholder="Name of package" />
                </div>
                <div className="small-top-margin">
                  <h5>{'Description'}</h5>
                  <ParseEditableTextarea
                    parseclass="CoveragePackages"
                    parseobjectid={this.state.item.id}
                    parsekey="description"
                    parsevalue={this.state.item.attributes.description}
                    placeholder="description of package" />
                </div>
                <div className="small-top-margin">
                  <h5>{'Hex Color'}</h5>
                  <div className="row">
                    <div className="small-2 medium-1" style={{backgroundColor:this.state.item.attributes.color}}>
                      <img className="full-width" src="/images/square.png" />
                    </div>
                    <div className="small-2 medium-11 light-grey-background" style={{paddingLeft:"10px", display:'flex', alignItems:'center'}}>
                      <input
                        type="text"
                        className="light-grey-background"
                        value={this.state.item.attributes.color}
                        onChange={this.onHexColorChange}
                        placeholder="..." />
                    </div>
                  </div>
                </div>
                <div className="small-top-margin">
                  <h5>{'Related Products'}</h5>
                  <ParseRelationalArray
                    parseclass={'CoveragePackages'}
                    parsevaluesclass={'CoverageProducts'}
                    parseobjectid={this.state.item.id}
                    parsekey="products"
                    parsevalue={this.state.item.attributes.products}
                  />
                </div>
                <div className="small-top-margin">
                  <h5>{'Status'}</h5>
                  <ParseEditableBoolean
                    parseclass="CoveragePackages"
                    parseobjectid={this.state.item.id}
                    parsekey="status"
                    parsevalue={this.state.item.attributes.status}
                   />
                </div>
                <div className="medium-top-margin">
                  <h5>{'Danger Zone'}</h5>
                  <div onClick={this.delete} className="button red-background white">{'Delete'}</div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(AdminCoverageSummaryEditPackage)
